import { vibeKeys } from './constants'

import { createEventEmitter } from '../event'

export const vibeEventEmitter = createEventEmitter()

export const emitVibe = msg => {
    vibeEventEmitter.emit(vibeKeys.VIBE, msg)
}
